import Layout from '@/components/Layout'
import { TrackingScripts } from '@/components/TrackingScripts'
import { toastOptions } from '@/config/toast.config'
import { useFacebookPixel } from '@/hooks/useFacebookPixel'
import { useReferral } from '@/hooks/useReferral'
import '@/styles/globals.css'
import '@/styles/toast.css'
import { CartProvider } from '@/contexts/CartContext'
import { LoginModalProvider, useLoginModal } from '@/contexts/LoginModalContext' // ✅
import type { AppProps } from 'next/app'
import { GoogleAnalytics } from 'nextjs-google-analytics'
import React from 'react'
import { Toaster } from 'react-hot-toast'
import ToastLimiter from '@/utils/toastManager'
import { QueryClient, QueryClientProvider } from 'react-query'
import LoginModal from '@/components/Auth/LoginModal' // ✅ Add this import

const queryClient = new QueryClient()

function GlobalModals() {
  const {
    isLoginOpen,
    setIsLoginOpen,
    setIsRegisterOpen,
    setIsForgotOpen,
    setLastOpened,
  } = useLoginModal()

  return (
    <LoginModal
      isOpen={isLoginOpen}
      setIsLoginOpen={setIsLoginOpen}
      setIsRegisterOpen={setIsRegisterOpen}
      setIsForgotOpen={setIsForgotOpen}
      setLastOpened={setLastOpened}
    />
  )
}

export default function App({ Component, pageProps }: AppProps) {
  useFacebookPixel()
  useReferral()

  return (
    <>
      <TrackingScripts />
      <link
        rel="stylesheet"
        crossOrigin="anonymous"
        href={process.env.NEXT_PUBLIC_SITE_URL + '/fonts.css'}
      />
      <QueryClientProvider client={queryClient}>
        <CartProvider>
          <LoginModalProvider>
            <Layout>
              <>
                <Toaster position="top-center" toastOptions={toastOptions} />
                <ToastLimiter />
                <GoogleAnalytics trackPageViews />
                <Component {...pageProps} />
                <GlobalModals /> {/* ✅ Mount login modal */}
              </>
            </Layout>
          </LoginModalProvider>
        </CartProvider>
      </QueryClientProvider>
    </>
  )
}
